import { Card } from './Card';
import {
	CardActions,
	CardBox,
	CardChip,
	CardContent,
	CardDescription,
	CardHeader,
	CardSubHeading,
	CardTitle,
} from './Card.styled';
import { ReactElement } from 'react';
import { Orientation, OrientationOptions } from './Card.props';

export type CustomCardProps = {
	title: string;
	subtitle?: string;
	description?: string;
	selected?: boolean;
	disabled?: boolean;
	chip?: ReactElement;
	actions?: ReactElement;
	Component: ReactElement;
	orientation?: Orientation;
}

export function CustomCard({
	selected,
	disabled,
	title,
	subtitle,
	description,
	chip,
	Component,
	actions,
	orientation = OrientationOptions.horizontal,
}: CustomCardProps) {
	return <Card selected={selected} disabled={disabled}>
		<CardBox $orientation={orientation} $padding={20} $gap={12}>
			{Component}
			<CardContent>
				<CardHeader>
					<CardTitle $fontSize={14}>{title}</CardTitle>
					{chip && <CardChip>{chip}</CardChip>}
				</CardHeader>
				{subtitle && <CardSubHeading>{subtitle}</CardSubHeading>}
				{description && <CardDescription>{description}</CardDescription>}
				{actions ? <CardActions>{actions}</CardActions> : null}
			</CardContent>
		</CardBox>
	</Card>;
}
